@if (resolvedTripType() && priceContext() && blockOffer()) {
  <section
    class="relative block-offer elevation-level-1 elevation-transition-ease fill grow flex flex--column no-underline nordic-blue-25-bg surface-secondary rounded-large overflow-hidden"
    (click)="emitClick(priceContext().price?.travelClass, resolvedTripType()); navigateToUrl(blockOffer().link)"
    [class.inner-hover]="innerLinkHover()"
    [attr.data-testid]="'offer-tile-heading-' + blockOffer().title"
    tabindex="0"
  >
    <div class="offer-area white-bg surface-primary grow">
      @if (aspectRatio()) {
        <section class="destination-image relative">
          <fin-content-image
            [aspectRatio$]="aspectRatio() | finToObservable"
            [imageData$]="blockOffer().imageData | finToObservable"
            [maxImageWidth]="MaxImageWidth"
            [fetchPriority]="fetchImagePriority()"
          />
        </section>
      }

      @if (badgeLabel()) {
        <fcom-tag
          [theme]="blockOffer().enableBlackTeaser ? TagTheme.BLACK_FRIDAY : TagTheme.POPULAR"
          class="special-offer-tag absolute"
          data-testid="offer-tile-badge-label"
          [roundingStyle]="isNewBrand() ? TagRoundingStyle.CURVE_RIGHT : TagRoundingStyle.DEFAULT"
        >
          @if (blockOffer().discountCode) {
            {{
              badgeLabel()
                | finLocalization
                  : {
                      amount:
                        blockOffer().discountCode.type === 'fixed'
                          ? (discountCodeFixedAmount() | finPrice: { stripZeroCents: true, useSymbol: true })
                          : blockOffer()?.discountCode?.amount,
                    }
            }}
          } @else {
            {{ badgeLabel() | finLocalization }}
          }

          @if (blockOffer().badgeIcon) {
            <fcom-icon className="white-text text-icon-reversed icon-small" [name]="blockOffer().badgeIcon" />
          }
        </fcom-tag>
      }

      <section class="fill pr-xsmall destination-text-content">
        @if (blockOffer().title) {
          <a
            class="no-decoration block price-link"
            [finLink]="blockOffer().link"
            (beforeNavigation)="emitClick(priceContext().price?.travelClass, resolvedTripType())"
            data-testid="offer-tile-price-link"
          >
            <h3
              data-testid="offer-tile-title"
              class="nordic-blue-900-text text-icon-primary mr-clear-y font-title-small truncate overflow-hidden"
            >
              {{ blockOffer().title }}
            </h3>
            <ng-container [ngTemplateOutlet]="price" [ngTemplateOutletContext]="priceContext()" />
          </a>
        }
        @if (showPriceCalendarButton()) {
          <div class="grow fill" [class.ps-xsmall-t]="isNewBrand()" [class.ps-xsmall-y]="!isNewBrand()">
            <fcom-button
              [text]="'destinationSearch.calendarButton' | finLocalization"
              [theme]="ButtonTheme.SECONDARY_OUTLINE"
              [mode]="ButtonMode.FILL"
              [size]="isNewBrand() ? ButtonSize.MEDIUM : ButtonSize.LARGE"
              (clickBtn)="emitCalendarClick($event, priceContext().price?.travelClass, resolvedTripType())"
              data-testid="block-offer-calendar-button"
            />
          </div>
        }
      </section>
    </div>
    @if (blockOffer()?.amDestination && flightHotelEnabled) {
      <button
        (click)="
          openAmContinueModalClick(blockOffer()?.amDestination.bookUrl, blockOffer()?.title, blockOffer()?.destination);
          $event.stopPropagation()
        "
        (mouseenter)="innerLinkHover.set(true)"
        (mouseleave)="innerLinkHover.set(false)"
        class="block flight-hotel no-underline ps-small"
        data-testid="offer-tile-flight-hotel-price-link"
      >
        <span class="flex flex--space-between flex--wrap flex--center">
          <span
            class="nordic-blue-900-text text-icon-primary underline ps-xsmall-r offer-tile-flight-hotel-title font-label-medium"
            data-testid="offer-tile-flight-hotel-title"
          >
            {{ 'destinationSearch.flightsAndHotel' | finLocalization }}</span
          >
          <span class="nordic-blue-900-text text-icon-primary font-body-medium">
            <span>
              {{
                'destinationSearch.flightAndHotelDuration'
                  | finLocalization: { days: blockOffer()?.amDestination.duration }
              }}</span
            >
            <span class="ps-xsmall-l font-label-medium" data-testid="offer-tile-flight-hotel-price-value">{{
              blockOffer()?.amDestination.price | finPrice: { roundPrice: true } | finEmpty
            }}</span>
          </span>
        </span>
      </button>
    }

    <ng-template #price let-price="price">
      @if (price && price.price) {
        <div
          class="nordic-blue-900-text text-icon-primary mr-clear-t ps-xxsmall-y font-body-medium"
          [attr.data-testid]="'offer-tile-starting-from-label-' + resolvedTripType()"
        >
          @if (showRoundTripPrice() === true) {
            {{ 'productCard.startingFromTitle.return' | finLocalization }}
          } @else {
            {{ 'productCard.startingFromTitle.' + CmsTripTypeMap[resolvedTripType()] | finLocalization }}
          }
        </div>
        <span
          class="offer-tile-price-value nordic-blue-900-text text-icon-primary medium-type font-headline-small"
          [class.heather-700-text]="isHighlightPrice()"
          [class.text-icon-accent]="isHighlightPrice()"
          data-testid="offer-tile-price-value"
          [attr.data-oneway]="blockOffer()?.onewayPrice?.price | finPrice: { roundPrice: true } | finEmpty"
          [attr.data-return]="blockOffer()?.returnPrice?.price | finPrice: { roundPrice: true } | finEmpty"
          >{{ price.price | finPrice: { roundPrice: true } | finEmpty }}</span
        >
      } @else {
        <div class="flex flex--middle mr-clear-t ps-xxsmall-y">
          <span
            class="nordic-blue-900-text text-icon-primary ms-xxsmall-r font-body-medium"
            data-testid="offer-tile-no-price-label"
            >{{ 'productCard.noPriceText' | finLocalization }}</span
          >
        </div>
      }
    </ng-template>
  </section>
}
